import { createSlice } from "@reduxjs/toolkit";

export const vendorProfileSlice = createSlice({
  name: "vendorProfile",
  initialState: {
    saveLoading: false,
    saveError: false,
    saveStatusCode: 0,
    saveMessage: "",
    getProfileLoading: false,
    getProfileError: false,
    getProfileData: null,
    getProfileStatusCode: 0,
  },
  reducers: {
    onVendorProfileSave: (state) => ({
      ...state,
      saveLoading: true,
      saveError: false,
      saveStatusCode: 0,
      saveMessage: "",
    }),
    onVendorProfileSaveSuccess: (state, { payload }) => {
      const { status_code = 200, message = "" } = payload;
      return {
        ...state,
        saveLoading: false,
        saveError: false,
        saveStatusCode: status_code,
        saveMessage: message,
      };
    },
    onVendorProfileSaveError: (state, { payload }) => {
      const { status_code = 400, message = "" } = payload;
      return {
        ...state,
        saveLoading: false,
        saveError: true,
        saveStatusCode: status_code,
        saveMessage: message,
      };
    },
    onVendorProfileSaveReset: (state) => ({
      ...state,
      saveLoading: false,
      saveError: false,
      saveStatusCode: 0,
      saveMessage: "",
    }),
    onGetVendorProfile: (state) => ({
      ...state,
      getProfileLoading: true,
      getProfileError: false,
      getProfileData: null,
      getProfileStatusCode: 0,
    }),
    onGetVendorProfileSuccess: (state, { payload }) => {
      const { data = null, status_code = 200 } = payload;
      return {
        ...state,
        getProfileLoading: false,
        getProfileError: false,
        getProfileData: data,
        getProfileStatusCode: status_code,
      };
    },
    onGetVendorProfileError: (state, { payload }) => {
      const { data = null, status_code = 400 } = payload;
      return {
        ...state,
        getProfileLoading: false,
        getProfileError: true,
        getProfileData: data,
        getProfileStatusCode: status_code,
      };
    },
  },
});

export const {
  onVendorProfileSave,
  onVendorProfileSaveSuccess,
  onVendorProfileSaveError,
  onVendorProfileSaveReset,
  onGetVendorProfile,
  onGetVendorProfileSuccess,
  onGetVendorProfileError,
} = vendorProfileSlice.actions;

export default vendorProfileSlice.reducer;
